import "./style/index.css";
import Image from './LazyImage';
export default Image;
export { Image };